import GoBackButton from '../GoBackButton';

type PodcastTableGoBackButtonProps = {
  podcastTitle?: string;
  onClick: () => void;
};

const PodcastTableGoBackButton = ({
  podcastTitle,
  onClick,
}: PodcastTableGoBackButtonProps) => (
  <GoBackButton onClick={onClick}>
    {podcastTitle
      ? `Return to all episodes of ${podcastTitle}`
      : 'Return to all podcasts'}
  </GoBackButton>
);

export default PodcastTableGoBackButton;
